export default __webpack_public_path__ + "static/media/AudienceDesigner_TrainingGuide_V2.3e833dae.pdf";